import React from 'react'
import PropTypes from 'prop-types'

import {
  SERVICE_LABEL_ADVISOR,
  SERVICE_LABEL_INVESTOR,
} from '../Landing/Helper/constants.js'

function Step0Modal({
  handleOptionChange,
  selectedOption,
  hideInvestorChoice,
}) {
  return (
    <div className="Esc-modal u-inlineBlock">
      <div className="Radio u-inlineBlock u-marginRight2gu">
        <input
          name="role"
          id="role1"
          type="radio"
          value={SERVICE_LABEL_ADVISOR}
          checked={selectedOption === SERVICE_LABEL_ADVISOR}
          onChange={handleOptionChange}
          className="Radio-button"
          data-analytics="cesc-Advisor"
        />
        <label htmlFor="role1" className="Radio-label u-marginBottom3gu">
          Financial Professional
        </label>
      </div>
      <div className="Radio u-inlineBlock">
        <input
          name="role"
          id="role2"
          type="radio"
          value={SERVICE_LABEL_INVESTOR}
          checked={selectedOption === SERVICE_LABEL_INVESTOR}
          onChange={handleOptionChange}
          className="Radio-button"
          disabled={hideInvestorChoice}
          data-analytics="cesc-Investor"
        />
        <label htmlFor="role2" className="Radio-label u-marginBottom3gu">
          Individual Investor
        </label>
      </div>
    </div>
  )
}

Step0Modal.propTypes = {
  handleOptionChange: PropTypes.func.isRequired,
  selectedOption: PropTypes.string,
  hideInvestorChoice: PropTypes.bool,
}

export default Step0Modal
